import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./i18n";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Kanban from "./pages/Kanban";
import RiskHeatMap from "./pages/RiskHeatMap";
import Registers from "./pages/Registers";
import DomainPage from "./pages/DomainPage";
import { Toaster } from "./components/ui/toaster";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

const DOMAIN_ROUTES = [
  "use-cases", "tasks", "approvals", "cyber-gov", "ai-readiness", "ai-projects",
  "regulatory", "business-impact", "kri", "kpi", "business-value", "soc",
  "app-perf", "net-perf", "soar", "integrations", "users", "audit-log",
];

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/app" element={<Protected><Layout /></Protected>}>
                <Route index element={<Navigate to="/app/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="kanban" element={<Kanban />} />
                <Route path="risk-heat-map" element={<RiskHeatMap />} />
                <Route path="registers" element={<Registers />} />
                {DOMAIN_ROUTES.map((k) => (
                  <Route key={k} path={k} element={<DomainPage moduleKey={k} />} />
                ))}
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
